import React from 'react';
import * as PropTypes from 'prop-types';
import MenuTitle from './MenuTitle';
import { Loading } from '../Loading/Loading';
import { Button } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import ConceptNameInput from './ConceptNameInput';
import WbAlert from '../Common/WbAlert';

const NewConceptMenu = ({
  isDirty,
  newConcept,
  back,
  close,
  loading,
  concepts,
}) => (
  <div className="fm-simple-panel">
    {loading && <Loading />}
    <MenuTitle back={back} close={close}>
      New
    </MenuTitle>
    <div className="fm-scroll">
      <h3>Start a New Design</h3>

      {isDirty && (
        <WbAlert variant="warning">
          This will start a new design. <i>Any unsaved changes will be lost.</i>
        </WbAlert>
      )}

      <p className="mb-1">
        Use this form to start a new design with all inputs reset to their
        defaults.
      </p>

      <Formik
        initialValues={{ conceptName: '' }}
        onSubmit={async (values) => {
          newConcept(values.conceptName);
        }}
      >
        {() => (
          <Form>
            <ConceptNameInput existingConcepts={concepts} />
            <Button type="submit" className="btn-block">
              Start New Design
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  </div>
);

NewConceptMenu.propTypes = {
  newConcept: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  concepts: PropTypes.array,
};

NewConceptMenu.defaultProps = {
  loading: false,
  concepts: [],
};

export default NewConceptMenu;
